module.exports = __webpack_public_path__ + "img/113.eb662bca.jpg";